import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import RoleManager from "../../../services/roleManage";
import { createAction } from "../../../utils/sagaHelper";
import { CONTROL_TYPE, ROLES_MANAGER_TYPE } from "../../../utils/enums";
import { DELETE, REORDER, UPDATE } from "../../../store/reducers/common-actions";

import EditableTable from "../EditableTable";
import AddButton from "../AddButton";
import IconButton from "../IconButton";
import CheckBox from "../CheckBox";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";
import {isRTL} from "../../../services/userModel.js";

const SectionItemEditableTable = ({ t, item, value, column, onPropChange, onLayout, itemAction, history, isLoading }) => {
    const [newValue, setNewValue] = useState("");
    const [searchString, setSearchString] = useState("");
    const [selectAll, setSelectAll] = useState(false);

    const handleOnPropChange = (propValue, col) => {
        if(column.isReadonly){
            return;
        }
        if(column.model.actionName) {
            itemAction(column.model.actionName + UPDATE, { item, value: propValue });
        } else {
            onPropChange({ [column.accessor]: value.map(valueItem=> valueItem[column.model.key] === propValue[column.model.key]
                ? { ...valueItem, ...propValue }
                : (col.type === CONTROL_TYPE.radioButton ? {...valueItem, [col.accessor]: false} : valueItem)
            )});
        }        
    }
    
    const handleOnDelete = id => {
        
        return new Promise((resolve, reject)=> {
            if(column.isReadonly){
                resolve();
            }
    
            if(column.model.actionName) {
                itemAction(column.model.actionName + DELETE, { id }).then(()=> resolve(), ()=> reject());
            } else {
                resolve();
                onPropChange({ [column.accessor]: value.filter(f=> f.id !== id) });
            }            
        });
    }

    const handleOnDrop = items => {
        if(column.isReadonly){
            return;
        }

        if(column.model.actionName) {
            itemAction(column.model.actionName + REORDER, { item, items });
        } else {
            onPropChange({ [column.accessor]: items });
        }        
    }

    const handleOnAdd = () => {
        if(column.isReadonly){
            return;
        }

        if(column.model.isLayoutForm) {
            onLayout(column.newItemUrl);
        } else {
            history.push(column.newItemUrl);
        }
    }

    const handleOnAddNewItem = () => {
        return new Promise(resolve=> {
            resolve();
            if(!column.isReadonly){
                if(column.model.actionName) {
                    itemAction(column.model.actionName + UPDATE, { item, value: {
                        id: "NewValue" + (value.length + 1),
                        [column.arrayNewItemAccessor]: newValue 
                    }}).then(()=> setNewValue(""));
                } else {
                    onPropChange({ 
                        [column.accessor]: value.concat([{
                            id: "NewValue" + (value.length + 1),
                            [column.arrayNewItemAccessor]: newValue 
                        }])
                    });
                    setNewValue("");
                }
            }
        });
    }

    const handleOnSelectAll = val => {
        const col = column.model && column.model.columns.find(f=> f.type === CONTROL_TYPE.checkbox);
        const newValue = value.map(m=> ({ ...m, [col.accessor]: val }));

        if(column.model.actionName) {
            itemAction(column.model.actionName + UPDATE, { item, value: newValue });
        } else {
            onPropChange({ [column.accessor]: newValue });
        }

        setSelectAll(val);
    }

    const isShowControlsContainer = () => {
        return isShowSelectAll();
    }

    const isShowSelectAll = () => {
        return column.model && column.model.columns.find(f=> f.type === CONTROL_TYPE.checkbox);
    }

    return (
        <div className={classNames("sectionItemEditableTable", {rtl: isRTL()})}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            {column.isShowNewItemControl && (
                <AddButton text={t("settings.ADD_BUTTON")} 
                    disabled={
                        (column.isDisabledNewItemControl && column.isDisabledNewItemControl(item)) ||
                        !RoleManager.instance.isAuthorized(ROLES_MANAGER_TYPE[CONTROL_TYPE.linkIconComponent], column.model.typeModel + "AddButton")
                    } 
                    onClick={handleOnAdd} 
                />
            )}
            {column.isShowArrayNewItemControl && (
                <div className={classNames("arrayItemsAddBlock")}>
                    <input type="text" value={newValue} className={classNames("sectionItemArrayItemValue")} 
                        onChange={e => setNewValue(e.currentTarget.value)}
                    />
                    <IconButton isIcon={true} iconName={"newOrder"} tooltipText={t("settings.ADD_BUTTON")}
                        onClick={handleOnAddNewItem}
                    />
                </div>
            )}
            {column.isShowSearch && (
                <input type="text" 
                    className={classNames("searchInput")} 
                    value={searchString} 
                    placeholder={t("orders.SEARCH_PLACEHOLDER")} 
                    onChange={(e) => setSearchString(e.target.value)}
                />
            )}
            {isShowControlsContainer() && (
                <div className={classNames("controlsContainer")}>
                    {isShowSelectAll() && (
                        <CheckBox id="selectAll" label="" value={selectAll} onChange={handleOnSelectAll} />
                    )}
                </div>
            )}
            <EditableTable
                model={column.model} items={column.onSearch ? column.onSearch(value, searchString) : value}
                onPropChange={handleOnPropChange}
                onDelete={handleOnDelete}
                onDrop={handleOnDrop}
                isLoading={isLoading}
                onLayout={onLayout}
            />
        </div>
    );
}


const mapStateToProps = state => ({
    isLoading: state.sectionsWrapperData.isLoading
});

const mapDispatchToProps = dispatch => {
    return {
        itemAction: (action, data) => dispatch(createAction(action, data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SectionItemEditableTable)));
